// base36 encoder for Nostr pubkeys, as used in NIP-5A nsite subdomain URLs.
// `pubkeyB36` is the author's raw 32-byte pubkey encoded with base36
// (lowercase, digits 0-9 then letters a-z, no padding) and is always exactly
// 50 characters.

const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz'

export function bytesToBase36(bytes: Uint8Array): string {
  // Convert byte array to a BigInt so we can divmod by 36.
  let n = 0n
  for (let i = 0; i < bytes.length; i++) {
    n = (n << 8n) | BigInt(bytes[i])
  }

  if (n === 0n) return '0'

  let out = ''
  while (n > 0n) {
    const r = Number(n % 36n)
    out = ALPHABET[r] + out
    n = n / 36n
  }
  return out
}

export function pubkeyToB36(pubkeyHex: string): string {
  const bytes = new Uint8Array(pubkeyHex.length / 2)
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = parseInt(pubkeyHex.slice(i * 2, i * 2 + 2), 16)
  }
  // NIP-5A: pubkeyB36 is always exactly 50 characters, pad with leading 0s.
  return bytesToBase36(bytes).padStart(50, '0')
}

export function isValidDTag(d: string): boolean {
  return /^[a-z0-9-]{1,13}$/.test(d) && !d.endsWith('-')
}
